// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18WnC","type":"styles_type__1hTFH","choices":"styles_choices__2L2-a"};